module.exports = __webpack_public_path__ + "static/img/61.7716f1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/61.png
// module id = Grs5
// module chunks = 1